<template>
  <div>
    <app-addon></app-addon>
    <div class="section-title text-center pt-5">
      <a name="contact"></a>
      <h1 class='display-1 text-uppercase font-weight-medium text-xs-center'>Contact Us</h1>
      <h3 class='header font-weight-medium text-xs-center'>We look forward to working with you!</h3>
    </div>
    <v-row class="fill-height ma-3"
           align="top"
           justify="center">
      <!-- <v-col xs=12 md=4>

        <v-form
          :model='contact'
          submit>
          <v-flex xs12 md12>
            <v-text-field maxlength='50'
                          label="Your Name"
                          v-model="name"
                          id='name'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field maxlength='90'
                          label="Company"
                          v-model="company"
                          id='company'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field maxlength="50"
                          label="Phone Number"
                          v-model="phone"
                          id='phone'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field maxlength="90"
                          label="E-Mail"
                          v-model="email"
                          id='email'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12 mt-3>
            <v-textarea label="Messages"
                        v-model="bodytext"
                        counter
                        maxlength='500'
                        id='bodytext'
                        auto-grow></v-textarea>
            <center>
              <div class="g-recaptcha" data-sitekey="6LeavKsUAAAAALsJqLc6FvrFpoUkGSsdi7zYLDgx"></div>
              <v-btn tile color="primary" @click='textSubmit'>Submit</v-btn>
            </center>

          </v-flex>
        </v-form>
      </v-col> -->

        <v-col cols=4 class='subtitle-2 hidden-sm-and-down'>
          <div class='headline'>Houston Digital</div>
          <div>
            Houston Digital has been in the lean software development industry since 1990. Bringing innovative ways to keep track of
            complex daily business functions. Headquartered in Idaho we are less than 20 miles away from great snow skiing, water
            sports and class 4 whitewater rafting and much more for the avid outdoorsman.
          </div>
            <br/>
          <p>
            Houston Digital Corp.<br/> 943 W Overland Rd. Suite 121<br/> Meridian, ID 83642<br/>
          </p>
          <A HREF='tel:2089471738'>208 947 1738</a> Phone<br/>
          <a href='mailto:sales@summitcrs.com'>sales@summitcrs.com</a><br/>


      </v-col>

    </v-row>
    <!-- start of footer -->
    <v-footer padless>
      <v-layout>
        <v-flex xs12>
          <v-card flat tile class="grey darken-3 white--text text-center">
            <v-card-text class="white--text">
              &copy; Houston Digital Corp. {{ new Date().getFullYear() }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-footer>
    <!-- End of footer -->

  </div>

</template>
<script>
  import axios from 'axios'
  import addon from './addon.vue';

  export default {
    components: {
      appAddon: addon,
    },
    DATA() {
      return{
        ads:[
          {
            plax: 'img/parallax/12r.png',
            img: 'img/ads/engage.png',
            text: 'Customers today are utilizing their mobile phones more than ever to find information, shop and communicate. With an estimated 98% open rate on SMS, businesses are investing in mobile communication and marketing. SMS is direct to your customer, cost-effective and simple to utilize. Providing the channels to communicate news, information, special offers, rewards and incentives.',
            titleimg: 'imgs/ads/banner.png',
            url: 'http://engagesms.net',
            css: 'hidden-sm-and-down',
            height: '685',
            width: '547'
          },
          {
            plax: 'img/parallax/plax4.jpg',
            img: 'img/ads/mopho.png',
            titleimg: 'img/ads/mophoprologo.png',
            text: 'Imaging has never been easier! MoPho Pro turns any Android or iOS device into a powerful media sharing tool that helps capture, organize and share media across your network. Remove unnecessary steps and let MoPho Pro wirelessly transfer all your images to the right location with a single touch.',
            title: 'MoPho Pro',
            url: 'http://www.summitcrs.com/MoPhoPro/index.html',
            css: 'mopho hidden-sm-and-down',
            height: '325',
            width: '415'
          },
        ],
        contact:{
          company: '',
          contactname: '',
          contactemail: '',
          contactphone: '',
          bodytext: ''
        }
      }
    },
    methods: {


      textSubmit(){
        let api = axios.create({
          baseURL: 'https://engagesms.net/app/api/ext/extSMS',
          method: 'post',
          headers: {
            'Authorization':'b441ae3b41e4d36c9f0eda7a882069abbdd3f26a6ddf80733716cfafd1c54ff0'
          },
          timeout: 100000
        });

        let msg =
          'Production Board Inquiry! \n ' +
          'Shop: ' + this.company + '\n ' +
          'Contact: ' + this.name + '\n ' +
          'Email: ' + this.email + '\n ' +
          'Phone: ' + this.phone + '\n ' +
          'Message: ' + this.bodytext

        let form_params= {
          appId: '3',
          recpNum: '2088410150',
          recpName: 'Cameron Schultz',
          recpMsg: msg,
          msgType: '2',
          recpComment: "none ya"

        }
        console.log(msg)
        console.log(form_params)
        api.post('/', form_params)
          .then(response => {
            console.log(response.data)
          }).catch(error => {
            console.log(error.toJSON())
          });
          // alert('Message Submited, please allow for 24-48 hours for response. If you require immediate assistance please call us at 208-947-1738.');
          // location.reload();

    }
    }
  }

</script>
